// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scoreId: __t.u64().primaryKey().name("score_id"),
  workspaceId: __t.option(__t.u64()).name("workspace_id"),
  executorLane: __t.string().name("executor_lane"),
  harnessVersion: __t.string().name("harness_version"),
  taskTag: __t.string().name("task_tag"),
  evidenceCompleteness: __t.f32().name("evidence_completeness"),
  setupFriction: __t.f32().name("setup_friction"),
  costVisibility: __t.f32().name("cost_visibility"),
  commandControl: __t.f32().name("command_control"),
  artefactCapture: __t.f32().name("artefact_capture"),
  avgLatencyMs: __t.u32().name("avg_latency_ms"),
  failureRecovery: __t.f32().name("failure_recovery"),
  sampleCount: __t.u32().name("sample_count"),
  lastUpdatedAt: __t.i64().name("last_updated_at"),
});
